import { render, staticRenderFns } from "./numbChoose.vue?vue&type=template&id=7f3f7b6d&scoped=true"
import script from "./numbChoose.vue?vue&type=script&lang=js"
export * from "./numbChoose.vue?vue&type=script&lang=js"
import style0 from "@/v1/assets/css/address.css?vue&type=style&index=0&id=7f3f7b6d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f7b6d",
  null
  
)

export default component.exports